import { PARSE_PRODUCT_CONFIGURATION, ProductConfigurationParsed, ProductConfigurationTypes } from '../actions/parse_product_configuration'

export default function parsedProductConfig(productConfig: ProductConfigurationParsed = {isValid: true}, action: ProductConfigurationTypes): ProductConfigurationParsed {
  switch (action.type) {
  case PARSE_PRODUCT_CONFIGURATION:
    return {isValid: action.isValid}
  default:
    return productConfig
  }
}